import { useState, useEffect} from 'react';
import Barchart from '../Barchart';
import CustomTable from "../CustomTable"
import LineChart from './LineChart';
import FetchAllAirportsDoughnutChart from "./FetchAllAirportsDoughnutChart"


function FetchAllAirportsCharts({TimeOption, RegionIndicator, Time, MeasurementIndicator, AirportCode, chartType}) {
    
    const [userData, setUserData] = useState([]);

    const [excelDataChart,setexcelDataChart] = useState([]);


    
    let component;

    
    useEffect(() => {
        
        //Url for getting Data for all Aiports
        var url = '/api/get_sum_indicator_by_year/' +Time+"/"+ MeasurementIndicator ;

       
        fetch(url).then((res) =>
           res.json().then((res) => {

            // TODO: FIX FOR MULTIPLE YEARS

            console.log("RESULT", res)
            let listOfIds = []
            let listOfValues = []

            listOfIds.push(res.data["Έτος"])
            listOfValues.push(res.data["Δείκτης"])


            setUserData({
                labels: listOfIds,
                datasets: [{
                  label: "",
                  data: listOfValues,
                  backgroundColor: "#0F8DD6",
                  borderColor: "black",
                  borderWidth: 0.1,
                }]
              })
            
            
            let exceldata = []
            for (let i = 0; i < listOfIds.length; i++) {
                exceldata.push({"Έτος": listOfIds[i], [MeasurementIndicator]: listOfValues[i]})
            }
            
            setexcelDataChart(exceldata)



           
          })
        )
        .catch((error) => {
          console.log("Refetching data for airport info!")
        });
      }, [Time, MeasurementIndicator,AirportCode]);




    if(userData.length !== 0 && Time.length !== 0){

        switch (chartType) {
            case 0:
                let BarChartoptions = {
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                      legend : {
                       display: false,
                      }
                    }
                  }
                component = <Barchart chartData={userData} chartOptions = {BarChartoptions} excelData ={excelDataChart}> </Barchart>
           
            break;
            case 1:
                component = <FetchAllAirportsDoughnutChart Time = {Time} MeasurementIndicator = {MeasurementIndicator}></FetchAllAirportsDoughnutChart>
           
            
            break;
            case 2:
                let matrixData = []
                for (let i = 0; i < userData.labels.length; i++) {
                    matrixData.push({"Έτος": userData.labels[i], [MeasurementIndicator]: userData.datasets[0].data[i]})
                  }

                component = <CustomTable data = {matrixData}></CustomTable>
            
            break;
        
            case 3:

            let LineChartoptions = {
                maintainAspectRatio: false,
                responsive: true,
                plugins: {
                  legend : {
                   display: false,
                  }
                }
              }
            
              component = <LineChart chartData={userData} chartOptions = {LineChartoptions} excelData ={excelDataChart}></LineChart>
            
            break;
            default:
            component = <h1>Παρακαλώ επιλέξτε τύπο διαγράμματος</h1>;
        }
       
        
        return (
            <div className="container filters-wrapper" style = {{marginTop: "5%"}}>
                <div style = {{display: "flex", marginTop: "3%"}}>
                    <div>
                        <p>Επιλεγμένη χρονική περίοδος</p>
                        <p><strong>{TimeOption}</strong></p>
                    </div>
                    <div style = {{marginLeft: "25%"}}>
                        <p>Επιλεγμένος δείκτης μέτρησης</p>
                        <p><strong>{RegionIndicator}</strong></p>
                    </div>
                </div>
                <div style = {{display: "flex"}}>
                    <div>
                        <p>Επιλεγμένη περίοδος</p>
                        <p><strong>{Time}</strong></p>
                    </div>
                    <div style = {{marginLeft: "32%"}}>
                        <p>Επιλεγμένοι δείκτες</p>
                        <p><strong>{MeasurementIndicator}</strong></p>
                    </div>

                </div>

                {component}
            
            </div>
        );
    }
    else {
        return <></>
    }
}

export default FetchAllAirportsCharts;
